import { animate, animateChild, query, style, transition, trigger } from '@angular/animations';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IonSpinner, Platform } from '@ionic/angular/standalone';
import { SlipComponentHeaderComponent } from '../slip-component-header/slip-component-header.component';
import { PaymentInfo, PaymentProgress, PaymentState, PaymentStatus, SlipInfo } from '../student-slip-modal.store';
import { HybridPaymentFormComponent } from './hybrid-payment-form/hybrid-payment-form.component';
import { StudentSlipPaymentInfoComponent } from './student-slip-payment-info/student-slip-payment-info.component';
import { WebPaymentFormComponent } from './web-payment-form/web-payment-form.component';

@Component({
  selector: 'app-student-slip-payment',
  templateUrl: './student-slip-payment.component.html',
  styleUrls: ['./student-slip-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideUpFadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(15%)' }),
        animate('200ms ease-in', style({ opacity: 1, transform: 'translateY(-3%)' })),
        animate('150ms ease-in', style({ opacity: 1, transform: 'translateY(0%)' }))
      ])
    ]),
    trigger('slideUpFadeInWithChild', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(15%)' }),
        animate('200ms ease-in', style({ opacity: 1, transform: 'translateY(-3%)' })),
        animate('150ms ease-in', style({ opacity: 1, transform: 'translateY(0%)' })),
        query('@delayedSlideUpFadeIn', animateChild())
      ])
    ]),
    trigger('delayedSlideUpFadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(15%)' }),
        animate('400ms 100ms ease-in', style({ opacity: 1, transform: 'translateY(0%)' }))
      ])
    ])
  ],
  imports: [
    SlipComponentHeaderComponent,
    StudentSlipPaymentInfoComponent,
    HybridPaymentFormComponent,
    WebPaymentFormComponent,
    IonSpinner
  ]
})
export class StudentSlipPaymentComponent {
  @Input() paymentInfo: PaymentInfo;
  @Input() paymentStatus: PaymentStatus;
  @Input() slipInfo: SlipInfo;
  @Input() progress: PaymentProgress;
  @Output() paymentMethodUpdated = new EventEmitter<string>();
  @Output() paymentStatusChange = new EventEmitter<PaymentStatus>();
  PaymentState = PaymentState;

  constructor(private platform: Platform) {}

  get isHybrid(): boolean {
    return this.platform.is('hybrid');
  }

  get showPaymentForm(): boolean {
    return (
      this.progress.state === PaymentState.Initialised &&
      (this.paymentInfo.status === 'pending' || this.paymentInfo.status === 'in-progress')
    );
  }
}
